import { GoogleLogin } from "react-google-login";
import { config } from "../../../config";
import google_logo_icon from "../../../img/google_icon.svg";
import { FormattedMessage, useIntl } from "react-intl";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import facebook_logo_icon from "../../../img/facebook_logo.svg";
import React from "react";
import { Button, Box, Stack, useTheme } from "@mui/material";
import { LOGIN_FACEBOOK, LOGIN_GOOGLE } from "../../../apollo-client/mutations";
import { showErrorToast } from "../../../toast/toast-service";
import { useApolloClient } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { getGraphQLErrorMessage } from "../../../helpers/network-helpers";

export const LoginSocialButtons = () => {
  const apolloClient = useApolloClient();
  const intl = useIntl();
  const history = useHistory();
  const theme = useTheme();

  const loginWithGoogle = async ({ accessToken }) => {
    try {
      const {
        data: { loginGoogle },
      } = await apolloClient.mutate({
        mutation: LOGIN_GOOGLE,
        variables: {
          accessToken,
        },
        // unfortunately this method wont be called, when errors occur, see https://github.com/apollographql/apollo-feature-requests/issues/385
        // onError: (error) => {
        //   history.push("/registration");
        //   showErrorToast(error.message);
        // },
        ignoreResults: true,
      });

      localStorage.setItem("token", loginGoogle.jwt);
      window.location.reload();
    } catch (error) {
      history.push("/registration");
      showErrorToast(getGraphQLErrorMessage(error));
    }
  };

  const loginWithFacebook = async ({ accessToken }) => {
    const {
      data: { loginFacebook },
    } = await apolloClient.mutate({
      mutation: LOGIN_FACEBOOK,
      variables: {
        accessToken,
      },
    });
    localStorage.setItem("token", loginFacebook.jwt);
    window.location.reload();
  };

  const onGoogleLoginError = () => {
    showErrorToast(
      intl.formatMessage({ id: "login-continue-with-google-error" })
    );
  };

  const onFacebookLoginError = () => {
    showErrorToast(
      intl.formatMessage({ id: "login-continue-with-facebook-error" })
    );
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, width: '100%' }}>
      <GoogleLogin
        clientId={config.googleOAuthClientID}
        buttonText="LoginButtonWithPopup with Google"
        onSuccess={loginWithGoogle}
        onFailure={() => onGoogleLoginError}
        render={(renderProps) => (
          <Button
            onClick={renderProps.onClick}
            variant="outlined"
            startIcon={
              <img 
                src={google_logo_icon} 
                alt="Google"
                style={{ width: '20px', height: '20px' }}
              />
            }
            sx={{
              width: '100%',
              maxWidth: '320px',
              height: '48px',
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 600,
              color: theme.palette.grey[700],
              borderColor: 'rgba(232, 121, 117, 0.2)',
              borderRadius: '12px',
              padding: '12px 20px',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(10px)',
              border: '2px solid rgba(232, 121, 117, 0.1)',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
              '&:hover': {
                borderColor: 'rgba(232, 121, 117, 0.4)',
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            <FormattedMessage id="login-continue-with-google" />
          </Button>
        )}
      />

      <FacebookLogin
        appId={config.facebookOAuthAppId}
        autoLoad={false}
        fields="name,email,picture"
        callback={loginWithFacebook}
        onFailure={() => onFacebookLoginError}
        size={"small"}
        render={(renderProps) => (
          <Button
            onClick={renderProps.onClick}
            variant="outlined"
            startIcon={
              <img 
                src={facebook_logo_icon} 
                alt="Facebook"
                style={{ width: '20px', height: '20px' }}
              />
            }
            sx={{
              width: '100%',
              maxWidth: '320px',
              height: '48px',
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 600,
              color: theme.palette.grey[700],
              borderColor: 'rgba(232, 121, 117, 0.2)',
              borderRadius: '12px',
              padding: '12px 20px',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(10px)',
              border: '2px solid rgba(232, 121, 117, 0.1)',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
              '&:hover': {
                borderColor: 'rgba(232, 121, 117, 0.4)',
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            <FormattedMessage id="login-continue-with-facebook" />
          </Button>
        )}
      />
    </Box>
  );
};

